import Container from './CommentPanel';
export default Container;

export { useCommentPanelLayout } from './CommentPanel';

export const componentName = 'CommentPanel';
